var _path, _path2, _ellipse, _path3, _ellipse2, _ellipse3, _path4, _path5, _ellipse4, _ellipse5, _path6, _path7, _path8, _ellipse6, _path9, _ellipse7, _path10, _path11, _ellipse8, _path12, _path13, _path14, _path15, _path16, _rect, _g, _path17, _g2, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarkickBearHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 174,
    viewBox: "0 0 147 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.1284 158.102C45.4916 146.241 44.371 136.314 46.5624 126.359L47.1889 112.979L50.0074 113.504L63.4738 115.603L73.8085 116.128C73.8085 116.128 72.8684 152.331 73.8085 152.331C74.7487 152.331 73.8085 162.824 73.8085 162.824C73.3098 165.351 72.4089 166.603 68.7978 167.022C64.1579 167.765 58.7769 167.546 55.9583 167.022C50.008 165.914 49.528 164.398 48.1284 158.102Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108.471 158.085C111.108 146.202 112.229 136.257 110.037 126.283L107.391 104.924L101.673 107.394L91.4703 110.578L81.5279 112.852C81.5279 112.852 83.7311 152.303 82.791 152.303C81.8509 152.303 82.791 162.816 82.791 162.816C83.2897 165.347 84.1906 166.602 87.8017 167.022C92.4416 167.766 97.8227 167.547 100.641 167.022C106.592 165.912 107.071 164.393 108.471 158.085Z",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 78.2998,
    cy: 142.121,
    rx: 32.274,
    ry: 25.3805,
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.934 143.061C104.934 155.174 92.8689 164.994 77.9864 164.994C63.1039 164.994 51.0392 155.174 51.0392 143.061C51.0392 130.947 63.1039 124.26 77.9864 124.26C92.8689 124.26 104.934 130.947 104.934 143.061Z",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.7991,
    cy: 157.272,
    rx: 11.6809,
    ry: 14.5982,
    transform: "rotate(-10.0703 48.7991 157.272)",
    fill: "black"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.6809,
    ry: 14.5982,
    transform: "matrix(-0.984594 -0.174856 -0.174856 0.984594 107.08 157.272)",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.174 169.381C83.0857 165.617 73.0063 165.832 55.1126 169.381L56.9927 165.935H98.6668L101.174 169.381Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2066 134.6C91.3741 130.892 91.8746 128.773 92.4 124.887L98.0401 129.273C95.9298 133.175 94.4139 135.046 91.1466 137.734C88.7641 136.089 87.3792 135.487 84.8798 134.6C84.3606 137.91 84.0194 139.891 82.9998 142.434C81.2868 142.21 80.3263 141.805 78.6131 142.12C77.1548 143.416 76.2218 145.12 75.1663 146.82C75.6293 144.667 76.1512 142.664 77.3597 140.554C79.0947 140.339 79.9895 140.324 81.7464 140.554C82.6907 137.106 82.9315 135.031 82.9998 131.154C85.7629 132.146 87.3288 132.765 90.2066 134.6Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 23.4424,
    cy: 44.0978,
    rx: 18.487,
    ry: 20.6804,
    transform: "rotate(-12.949 23.4424 44.0978)",
    fill: "black"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.557,
    cy: 24.2975,
    rx: 18.487,
    ry: 20.6804,
    transform: "rotate(-12.949 109.557 24.2975)",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7015 64.4608L19.703 64.4537L19.7044 64.4466C22.5308 50.2529 27.4528 41.4673 36.3094 32.2462C43.1108 25.165 52.6966 20.4585 62.7354 18.3063C72.7799 16.1529 83.0951 16.5962 91.2804 19.6075C101.069 23.2261 110.777 30.2921 118.38 41.647L118.382 41.6495C125.766 52.6407 129.44 64.6575 129.638 74.9211C129.837 85.2428 126.543 93.3885 120.514 97.3311C106.264 106.288 94.9206 111.793 82.9593 114.602C71.0019 117.409 58.2773 117.556 41.2209 115.567C38.2368 115.172 35.075 113.412 32.0316 110.401C28.9972 107.399 26.1951 103.262 23.9467 98.381C19.4435 88.6054 17.2898 76.1329 19.7015 64.4608Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1624 80.9087C25.1479 76.1117 26.2157 69.0683 29.4108 62.6764C32.6136 56.2693 37.5356 51.3468 42.2834 50.2551C46.8473 49.2057 51.551 51.5304 54.9524 56.186C58.3353 60.8163 60.1458 67.4452 58.8901 74.1061C58.3286 77.0842 56.4421 79.6312 53.6442 81.6421C50.8395 83.6579 47.2173 85.0547 43.4763 85.7071C39.7308 86.3603 36.008 86.2426 33.0231 85.3701C30.0255 84.494 28.0175 82.9447 27.1624 80.9087Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.536 59.8991C118.253 54.7039 114.216 48.8343 108.55 44.4798C102.87 40.115 96.2924 37.8367 91.5447 38.9283C86.9808 39.9777 83.7648 44.1234 82.7384 49.7971C81.7176 55.4399 82.9843 62.1938 87.0232 67.6373C88.829 70.0712 91.6385 71.5384 95.0338 72.1253C98.4372 72.7136 102.306 72.3881 105.956 71.341C109.611 70.2927 112.908 68.5608 115.212 66.4722C117.526 64.3748 118.656 62.1041 118.536 59.8991Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 4
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.3931,
    cy: 71.9682,
    rx: 12.9668,
    ry: 13.7869,
    transform: "rotate(-12.949 49.3931 71.9682)",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.2367 69.1532C61.594 75.0561 58.1937 80.876 52.642 82.1526C51.2998 82.4612 49.9547 82.476 48.6674 82.2375C49.303 81.7447 49.6269 80.8764 49.4251 79.9989C49.1537 78.8183 48.0335 78.0682 46.9232 78.3235C45.8128 78.5788 45.1328 79.7428 45.4042 80.9234C45.4134 80.9634 45.4236 81.0029 45.4347 81.0419C42.8705 79.5686 40.8717 76.9916 40.1323 73.7759C38.775 67.8731 42.1753 62.0531 47.727 60.7766C48.9775 60.489 50.2305 60.4566 51.437 60.6463C49.6641 61.4498 48.6579 63.5104 49.1376 65.5968C49.6805 67.9579 51.9209 69.458 54.1415 68.9474C56.3622 68.4368 57.7223 66.1088 57.1794 63.7477C57.1647 63.6839 57.1488 63.6207 57.1317 63.5582C58.6149 65.0166 59.7261 66.9326 60.2367 69.1532Z",
    fill: "black"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.7716,
    cy: 61.5341,
    rx: 12.9668,
    ry: 13.7869,
    transform: "rotate(-12.949 94.7716 61.5341)",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.892 59.1152C105.249 65.018 101.849 70.838 96.2973 72.1145C94.9551 72.4231 93.61 72.4379 92.3228 72.1995C92.9584 71.7066 93.2823 70.8383 93.0806 69.9607C92.8091 68.7802 91.6889 68.0301 90.5786 68.2854C89.4683 68.5407 88.7882 69.7047 89.0597 70.8853C89.0689 70.9253 89.0791 70.9649 89.0902 71.0039C86.5259 69.5306 84.527 66.9536 83.7876 63.7378C82.4303 57.835 85.8306 52.015 91.3823 50.7385C92.6328 50.451 93.8858 50.4185 95.0922 50.6082C93.3194 51.4118 92.3133 53.4723 92.793 55.5586C93.3359 57.9197 95.5762 59.4199 97.7969 58.9093C100.018 58.3987 101.378 56.0707 100.835 53.7096C100.82 53.6458 100.804 53.5827 100.787 53.5202C102.27 54.9785 103.381 56.8945 103.892 59.1152Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3527 75.3341C64.2845 76.1311 64.2605 77.4227 65.8333 78.6687C69.3711 81.4714 73.1341 82.4558 75.2718 81.9643C77.4094 81.4727 80.0951 79.5083 82.3232 74.8771C83.1928 73.0696 82.3012 71.9885 80.3996 72.1043C78.4979 72.2201 68.421 74.537 66.3527 75.3341Z",
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 70.2732,
    cy: 77.005,
    rx: 2.50672,
    ry: 1.25336,
    transform: "rotate(-12.949 70.2732 77.005)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0015 72.4094C67.7664 70.6431 69.9888 69.3538 72.54 68.7672C74.6488 68.2823 76.7653 68.3275 78.7683 68.8198C76.59 67.182 74.1558 66.4667 71.8133 67.0053C69.241 67.5968 67.2296 69.5967 66.0015 72.4094Z",
    fill: "#C2CFD1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7058 36.6447C21.7701 36.943 21.9773 37.1908 22.2591 37.3077L26.1868 38.8707C26.5195 39.0034 26.7436 39.3186 26.7605 39.677C26.787 40.0344 26.605 40.3745 26.2948 40.5528L22.657 42.6992C22.5293 42.773 22.4213 42.8761 22.3395 42.9995L22.2183 43.1941C22.1863 43.2679 22.1667 43.3473 22.1622 43.4282L21.8468 47.6472C21.8278 47.8537 21.7449 48.0492 21.6082 48.2062C21.2632 48.5811 20.6819 48.6124 20.2983 48.2766L17.1661 45.4363C16.9349 45.2334 16.6198 45.1555 16.321 45.2274L12.1952 46.254C11.85 46.3398 11.4873 46.2183 11.2642 45.9416C11.0399 45.6682 10.9855 45.2934 11.1235 44.9678L12.8284 41.0769C12.9694 40.788 12.9528 40.4468 12.7849 40.1726L10.5424 36.5914C10.4939 36.5093 10.4579 36.4201 10.4381 36.327L10.4281 36.2311C10.4118 36.1741 10.4051 36.1161 10.4068 36.0573L10.4269 35.9612L10.4527 35.8078L10.6409 35.5055C10.837 35.253 11.1464 35.1161 11.4649 35.1422L15.6643 35.5489C15.9705 35.5803 16.2724 35.4586 16.4724 35.2254L19.2119 31.9797C19.4427 31.705 19.8077 31.5828 20.1569 31.6619C20.5032 31.7473 20.7684 32.0253 20.838 32.3757L21.7058 36.6447Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M36.939 126.767C39.5493 120.814 44.2143 116.427 52.0467 112.354L54.9476 132.094C54.9476 132.094 52.3844 138.928 45.7124 139.614C39.0405 140.3 34.3286 132.721 36.939 126.767Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.0206 87.1702C72.948 86.497 74.884 84.0502 74.3447 81.705C74.3193 81.5943 74.4503 81.5084 74.5308 81.5886C75.0016 82.0576 75.3352 82.6257 75.4838 83.2719C76.0231 85.6171 73.9216 88.102 70.7899 88.8221C67.6583 89.5422 64.6824 88.2249 64.1432 85.8797C64.0886 85.6425 64.4036 85.5445 64.5643 85.7273C65.7247 87.0475 67.8402 87.6716 70.0206 87.1702Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.1008 84.3925C79.1734 85.0656 76.3631 83.7102 75.8238 81.365C75.7984 81.2544 75.6431 81.2343 75.6057 81.3416C75.387 81.9691 75.3351 82.6259 75.4837 83.2721C76.023 85.6173 78.9988 86.9346 82.1305 86.2145C85.2621 85.4944 87.3636 83.0095 86.8243 80.6643C86.7698 80.4271 86.4436 80.4765 86.3789 80.7112C85.9117 82.4057 84.2812 83.8911 82.1008 84.3925Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.5092,
    y: 81.667,
    width: 1.0962,
    height: 1.98051,
    transform: "rotate(-12.95 74.5092 81.667)",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1128_4780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.3066 85.5505L60.9762 85.4851C54.0417 84.1118 47.3068 88.6201 45.9336 95.5546L45.9331 95.5569C42.6943 111.912 63.452 137.139 63.452 137.139C63.452 137.139 92.2578 121.727 95.4966 105.372L95.497 105.37C96.8703 98.4353 92.362 91.7005 85.4275 90.3272L85.0971 90.2618C79.5723 89.1677 74.1744 91.8068 71.5135 96.4318C70.816 91.1418 66.8313 86.6446 61.3066 85.5505Z",
    fill: "url(#paint0_linear_1128_4780)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1128_4780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 88,
    width: 47,
    height: 43
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3483 128.965C67.3181 131.564 62.0024 130.511 59.2668 126.573C57.8955 124.598 56.5913 122.578 55.3592 120.519C53.0817 116.714 50.9145 112.475 49.5003 108.287C48.0816 104.085 47.4518 100.026 48.1428 96.5359L48.1432 96.5338C49.2844 90.7711 55.0635 87.0609 61.0511 88.2466L61.3654 88.3088C66.134 89.2532 69.4685 93.6802 70.1027 98.0884L70.6237 100.924L72.1862 98.501C74.4526 94.6672 79.2227 91.8452 83.9913 92.7895L84.3055 92.8518C90.2932 94.0375 94.222 99.6703 93.0808 105.433L93.0804 105.435C92.3893 108.925 90.2599 112.438 87.347 115.781C84.4432 119.115 80.824 122.208 77.268 124.858C75.3443 126.292 73.3685 127.663 71.3483 128.965Z",
    fill: "url(#paint1_linear_1128_4780)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1128_4780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3483 128.965C67.3181 131.564 62.0024 130.511 59.2668 126.573C57.8955 124.598 56.5913 122.578 55.3592 120.519C53.0817 116.714 50.9145 112.475 49.5003 108.287C48.0816 104.085 47.4518 100.026 48.1428 96.5359L48.1432 96.5338C49.2844 90.7711 55.0635 87.0609 61.0511 88.2466L61.3654 88.3088C66.134 89.2532 69.5994 93.0194 70.2336 97.4276L70.7546 100.263L72.3171 97.8401C74.5835 94.0064 79.2227 91.8452 83.9913 92.7895L84.3055 92.8518C90.2932 94.0375 94.222 99.6703 93.0808 105.433L93.0804 105.435C92.3893 108.925 90.2599 112.438 87.347 115.781C84.4432 119.115 80.824 122.208 77.268 124.858C75.3443 126.292 73.3685 127.663 71.3483 128.965Z",
    fill: "url(#paint2_linear_1128_4780)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1128_4780)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8688,
    cy: 114.836,
    rx: 28.9682,
    ry: 18.6946,
    transform: "rotate(11.2016 67.8688 114.836)",
    fill: "#FF3E30"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_1128_4780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.1526 106.586C47.6682 112.385 50.0819 118.224 52.6456 123.452C54.1605 126.541 55.7804 129.562 57.4975 132.503C60.2412 137.2 66.397 138.419 70.7241 135.122C73.4321 133.058 76.0812 130.882 78.6591 128.604C83.0219 124.747 87.4786 120.269 91.0901 115.485L85.9199 118.059C73.7057 124.141 58.9261 121.214 49.9515 110.936L46.1526 106.586Z",
    fill: "#BF0E07"
  })))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0795 121.127C63.1702 127.037 54.4068 134.572 45.886 138.516L40.5592 131.936L37.4258 126.923C37.4258 126.923 51.0297 109.798 58.246 109.22C65.4624 108.643 68.9889 115.217 66.0795 121.127Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7191 116.756C76.8806 120.849 98.991 124.034 108.38 123.947L108.38 118.933L106.5 107.026C106.5 107.026 79.3801 102.6 72.6127 105.171C65.8453 107.743 66.5575 112.663 71.7191 116.756Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1128_4780",
    x: 45.59,
    y: 75.2388,
    width: 50.1533,
    height: 65.9004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1128_4780"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1128_4780",
    result: "effect2_innerShadow_1128_4780"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1128_4780",
    x: 15.2182,
    y: 71.6479,
    width: 105.301,
    height: 86.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1128_4780"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_1128_4780",
    x: 35.1526,
    y: 95.5859,
    width: 66.9375,
    height: 52.3955,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "effect1_foregroundBlur_1128_4780"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1128_4780",
    x1: 73.2018,
    y1: 87.9062,
    x2: 63.452,
    y2: 137.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3D30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "#EB2B1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1128_4780",
    x1: 72.6783,
    y1: 90.5492,
    x2: 65.0879,
    y2: 128.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189655,
    stopColor: "#CC1009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.564655,
    stopColor: "#CC1009",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1128_4780",
    x1: 65.1533,
    y1: 128.548,
    x2: 72.6783,
    y2: 90.5492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC1009"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295652,
    stopColor: "#ED2416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786458,
    stopColor: "#FF958D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarkickBearHeart);
export default __webpack_public_path__ + "static/media/earkick-bear-heart.94c3c344128ae576fecb19b57630aa60.svg";
export { ForwardRef as ReactComponent };